import React, { Component } from "react";
import Image from '../global/Image';

export default class PagePlaces extends Component {
	
	constructor(){
		super()
		this.state = {
			active: 0,
		}
		this.handleToggle = this.handleToggle.bind(this);
	}
	
	handleToggle(_evt) {  
	    this.setState({ active : parseFloat(_evt.currentTarget.getAttribute('data-index')) });
    }
	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
				
				<div data-id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--space-' + block.space_after + ' c-page__block--' + block.rule_after}>
			    	
			    	<div className="l-content l-content--fixed-width">
			    		
			    		<div className="l-grid c-places">
			    		
			    			{block.heading &&
				    			<div className="l-grid__col">
				    				<h2 className="c-paragraph c-paragraph--space" dangerouslySetInnerHTML={{__html:block.heading}}></h2>
				    			</div>
			    			}
							
							<div className="l-grid__col l-grid__col--m-6-12">
							
								<div className="c-places__images">
															
									{block.places.map((place,i) =>
										{	
											if (i === this.state.active) {
												return (
													<div className="c-places__images__image state-active" key={i}>			    				    
											    		<Image srcset={place.srcset} src={place.src}></Image>
													</div>
												)
											} else {
												return (
													<div className="c-places__images__image" key={i}>			    				    
											    		<Image srcset={place.srcset} src={place.src}></Image>
													</div>
												)
											}
										}
									)}
								
								</div>
																	
							</div>
							
							<div className="l-grid__col l-grid__col--m-6-12">
								<ul className="c-places__list">
									{block.places.map((place,i) =>
										{	
											if (i === this.state.active) {
												return (
													<li className="c-places__list__item state-active" dangerouslySetInnerHTML={{__html:place.label}} key={i}></li>
												)
											} else {
												return (
													<li className="c-places__list__item" key={i}>
														<a className="c-places__list__link" onClick={this.handleToggle} data-index={i}dangerouslySetInnerHTML={{__html:place.label}}></a>
													</li>
												)
											}
										}
								)}	
								</ul>
							</div>
			    			
			    		</div>
			    		
			    	</div>
			    	
			    </div>
			    
			)
			
		} else {
			
			return null;
		
		}
	}
}
